/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type Setting,
    SettingFromJSON,
    SettingToJSON,
} from '../models/Setting';
import {
    type SettingUpdate,
    SettingUpdateFromJSON,
    SettingUpdateToJSON,
} from '../models/SettingUpdate';

export interface SettingsReadSettingByIdRequest {
    id: string;
}

export interface SettingsUpdateSettingRequest {
    id: string;
    settingUpdate: SettingUpdate;
}

export interface SettingsValidateUpdateSettingRequest {
    id: string;
    settingUpdate: SettingUpdate;
}

/**
 * SettingsApi - interface
 * 
 * @export
 * @interface SettingsApiInterface
 */
export interface SettingsApiInterface {
    /**
     * Creates request options for settingsReadSetting without sending the request
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsReadSettingRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Since there\'s only a single settings row, we don\'t take an ID parameter here.
     * @summary Fetch the settings entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsReadSettingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Setting>>;

    /**
     * Since there\'s only a single settings row, we don\'t take an ID parameter here.
     * Fetch the settings entity
     */
    settingsReadSetting(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Setting>;

    /**
     * Creates request options for settingsReadSettingById without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsReadSettingByIdRequestOpts(requestParameters: SettingsReadSettingByIdRequest): Promise<runtime.RequestOpts>;

    /**
     * This route aids to keep the frontend settings repository consistent to the other respositories
     * @summary Fetch the settings entity by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsReadSettingByIdRaw(requestParameters: SettingsReadSettingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Setting>>;

    /**
     * This route aids to keep the frontend settings repository consistent to the other respositories
     * Fetch the settings entity by id
     */
    settingsReadSettingById(requestParameters: SettingsReadSettingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Setting>;

    /**
     * Creates request options for settingsUpdateSetting without sending the request
     * @param {string} id 
     * @param {SettingUpdate} settingUpdate 
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsUpdateSettingRequestOpts(requestParameters: SettingsUpdateSettingRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the setting entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * @summary Update setting
     * @param {string} id 
     * @param {SettingUpdate} settingUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsUpdateSettingRaw(requestParameters: SettingsUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Setting>>;

    /**
     * Update the setting entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * Update setting
     */
    settingsUpdateSetting(requestParameters: SettingsUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Setting>;

    /**
     * Creates request options for settingsValidateUpdateSetting without sending the request
     * @param {string} id 
     * @param {SettingUpdate} settingUpdate 
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsValidateUpdateSettingRequestOpts(requestParameters: SettingsValidateUpdateSettingRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate an update struct for the setting entity.
     * @summary Validate setting update
     * @param {string} id 
     * @param {SettingUpdate} settingUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    settingsValidateUpdateSettingRaw(requestParameters: SettingsValidateUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate an update struct for the setting entity.
     * Validate setting update
     */
    settingsValidateUpdateSetting(requestParameters: SettingsValidateUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI implements SettingsApiInterface {

    /**
     * Creates request options for settingsReadSetting without sending the request
     */
    async settingsReadSettingRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/settings/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Since there\'s only a single settings row, we don\'t take an ID parameter here.
     * Fetch the settings entity
     */
    async settingsReadSettingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Setting>> {
        const requestOptions = await this.settingsReadSettingRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingFromJSON(jsonValue));
    }

    /**
     * Since there\'s only a single settings row, we don\'t take an ID parameter here.
     * Fetch the settings entity
     */
    async settingsReadSetting(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Setting> {
        const response = await this.settingsReadSettingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for settingsReadSettingById without sending the request
     */
    async settingsReadSettingByIdRequestOpts(requestParameters: SettingsReadSettingByIdRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling settingsReadSettingById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/settings/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This route aids to keep the frontend settings repository consistent to the other respositories
     * Fetch the settings entity by id
     */
    async settingsReadSettingByIdRaw(requestParameters: SettingsReadSettingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Setting>> {
        const requestOptions = await this.settingsReadSettingByIdRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingFromJSON(jsonValue));
    }

    /**
     * This route aids to keep the frontend settings repository consistent to the other respositories
     * Fetch the settings entity by id
     */
    async settingsReadSettingById(requestParameters: SettingsReadSettingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Setting> {
        const response = await this.settingsReadSettingByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for settingsUpdateSetting without sending the request
     */
    async settingsUpdateSettingRequestOpts(requestParameters: SettingsUpdateSettingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling settingsUpdateSetting().'
            );
        }

        if (requestParameters['settingUpdate'] == null) {
            throw new runtime.RequiredError(
                'settingUpdate',
                'Required parameter "settingUpdate" was null or undefined when calling settingsUpdateSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/settings/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SettingUpdateToJSON(requestParameters['settingUpdate']),
        };
    }

    /**
     * Update the setting entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * Update setting
     */
    async settingsUpdateSettingRaw(requestParameters: SettingsUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Setting>> {
        const requestOptions = await this.settingsUpdateSettingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingFromJSON(jsonValue));
    }

    /**
     * Update the setting entity. Since we know the ID of the singleton entity after reading, we take an ID argument here to keep the API consistent with other update endpoints.
     * Update setting
     */
    async settingsUpdateSetting(requestParameters: SettingsUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Setting> {
        const response = await this.settingsUpdateSettingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for settingsValidateUpdateSetting without sending the request
     */
    async settingsValidateUpdateSettingRequestOpts(requestParameters: SettingsValidateUpdateSettingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling settingsValidateUpdateSetting().'
            );
        }

        if (requestParameters['settingUpdate'] == null) {
            throw new runtime.RequiredError(
                'settingUpdate',
                'Required parameter "settingUpdate" was null or undefined when calling settingsValidateUpdateSetting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/settings/{id}/validate`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SettingUpdateToJSON(requestParameters['settingUpdate']),
        };
    }

    /**
     * Validate an update struct for the setting entity.
     * Validate setting update
     */
    async settingsValidateUpdateSettingRaw(requestParameters: SettingsValidateUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.settingsValidateUpdateSettingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate an update struct for the setting entity.
     * Validate setting update
     */
    async settingsValidateUpdateSetting(requestParameters: SettingsValidateUpdateSettingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.settingsValidateUpdateSettingRaw(requestParameters, initOverrides);
    }

}
